module.exports = __webpack_public_path__ + "static/hat.c1fc33ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hat.jpg
// module id = 559
// module chunks = 70144966829960